import Vue from 'vue';
// @ts-ignore
import es from 'vee-validate/dist/locale/es';
import VeeValidate, { Validator } from 'vee-validate';

Vue.use(VeeValidate);
